"use client";
import { Link } from "@/app/components/lib/navigation/Link";
import { useRef, useState } from "react";
import useProductPopup from "@/hooks/useProductPopup";
import { Config_Customize } from "@/api/AppApi/services/home/interfaces/ICategory";
import { ownsHorizontalGesture } from "@/app/components/lib/Embla-slider/nestedScroller";

interface Props extends React.HTMLProps<HTMLDivElement> {
  isEvent: boolean;
  slug: string;
  Customize?: Config_Customize;
}
const EventProductClick: React.FC<
  React.PropsWithChildren<{ slug: string }>
> = ({ children, slug }) => {
  const { handleOpenPopup } = useProductPopup();
  return (
    <div onClick={() => handleOpenPopup({ productID: slug })}>{children}</div>
  );
};

const ProductClick: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  isEvent,
  slug,
  Customize,
  ...props
}) => {
  const [pressed, setPressed] = useState(false);
  const pressStart = useRef<{ x: number; y: number } | null>(null);

  const onPointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
    if (ownsHorizontalGesture(e.target)) return;
    pressStart.current = { x: e.clientX, y: e.clientY };
    setPressed(true);
  };
  const releasePress = () => {
    pressStart.current = null;
    setPressed(false);
  };
  const onPointerMove = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!pressStart.current) return;
    if (
      Math.abs(e.clientX - pressStart.current.x) > 8 ||
      Math.abs(e.clientY - pressStart.current.y) > 8
    ) {
      releasePress();
    }
  };

  const saveScrollPosition = () => {
    sessionStorage.setItem("scrollPosition", window.scrollY.toString());
    sessionStorage.setItem("scrollRestorePath", window.location.pathname);
  };
  const handleProductClick = () => {
    saveScrollPosition();
  };
  return (
    <div
      {...props}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={releasePress}
      onPointerCancel={releasePress}
      onPointerLeave={releasePress}
      style={{
        ...(props.style as React.CSSProperties),
        transition: "transform 110ms ease-out, opacity 110ms ease-out",
        transform: pressed ? "scale(0.97)" : undefined,
        opacity: pressed ? 0.9 : undefined,
      }}
    >
      {isEvent ? (
        <EventProductClick slug={slug}>{children}</EventProductClick>
      ) : (
        <Link
          skipCheckingForLang
          prefetch={false}
          href={`/products/${slug}`}
          onClick={handleProductClick}
        >
          {children}
        </Link>
      )}
    </div>
  );
};

export default ProductClick;
